import HTTP from '../HTTP';

export default {
    getSubmissions(companyId = null) {
        if (companyId) {
            return HTTP.get('/submissions', {
                params: {
                    company_id: companyId
                }
            });
        }
        return HTTP.get('/submissions');
    },
    getSubmission(id) {
        return HTTP.get(`/submissions/${id}`);
    },
    createSubmission(data) {
        return HTTP.post('/submissions', data);
    },
    // editSubmission(id, data) {
    //     return HTTP.put(`/submissions/${id}`, data);
    // },
    removeSubmission(id) {
        return HTTP.delete(`/submissions/${id}`);
    },
    approveSubmission(id) {
        return HTTP.put(`/submissions/${id}/approve/`);
    },
    updateSubmission(id, data) {
        return HTTP.put(`/submissions/${id}`, data);
    }
};
